import './Research.css';
import NewDynamicBackground from '../components/NewDynamicBackground'; // import background


function Research() {
  return (
    <div className="research-page">
        <NewDynamicBackground variant={2} />

      {/* Overview */}
      <section className="research-overview">
         <div className="overview-text">
         <h2>Research Overview</h2>
        </div>

        <div className="overview-text">
        My recent research focuses on how innovative HCI technologies and design can enhance existing healthcare solutions, enable new care paradigms, and empower end users in real-world contexts. 
        Specifically, my work explores the following areas: <strong>(1)</strong> how everyday users can be supported in developing healthier behaviors and lifestyles through lightweight micro-interactions embedded in daily life; <strong>(2)</strong>  how biofeedback can be seamlessly integrated into the routines of high-stress populations to strengthen self-regulation through non-screen-based interactions with calming experiential qualities; <strong>(3)</strong> how stroke survivors and older adults can be meaningfully engaged in long-term home rehabilitation with minimal burden and personalized recovery journeys; and <strong>(4)</strong>  how clinical AI can be designed as a collaborative partner that fits naturally into healthcare workflows, supporting clinicians in patient monitoring and treatment planning.
        </div>

       <div className="overview-text">
        My work is rooted in user-centered design and design thinking. I ground my projects in user research and contextual inquiry to ensure that the systems I develop meaningfully support users’ experiences and fit within real-life contexts.
        At the same time, I enjoy exploring design-driven processes. I collaborate with design professionals to let concepts expand creatively before refining them through iterative user involvement.
        I have worked with a wide range of technologies, but rather than focusing solely on technological invention, I am particularly interested in innovating the “bridge” that enables technologies to better serve health-related purposes and support people in specific contexts.
        My research is inherently interdisciplinary, shaped through collaborations with experts in Human-Computer Interaction, clinical practice, rehabilitation, psychology, computer science, and the arts.
        </div>


         <img
         className="overview-image"
          src={`${process.env.PUBLIC_URL}/assets/researchoverview_img.png`}
          alt="Research overview"
        />

      </section>

      {/* Focus 1 */}
      <section className="research-focus">

        <div className="focus-title">
         Collaborative Clinial-AI Interactions in Medical Imaging
        </div>

        <div className="focus-content">
          <p>
          This research aims to improve collaboration between clinicians and AI in medical imaging for cancer care. Just like teamwork between humans, effective clinician-AI collaboration relies on combining the unique strengths of both partners. Currently, AI tools in imaging often act as standalone assistants, offering only simple accept-or-reject options, which limits meaningful interaction. Clinicians also need AI that can adapt to the task, the context, and their expertise, such as taking the lead in routine tasks while letting humans remain in control during complex or high-risk cases.
          To address these challenges, we are developing interactive AI systems that act as complementary partners. These systems support clinicians through features like annotation, editing, and validation, while dynamically adjusting their role based on task complexity and confidence in AI outputs. Grounded in Human-Computer Interaction principles and Adaptive User Interface, the approach is designed to reduce cognitive load, enhance performance, and enable flexible, context-sensitive collaboration.
         </p>

        </div>

      </section>



      {/* Focus 2 */}
      <section className="research-focus">

        <div className="focus-title">
         AI-powered Sensor-based E-Rehabiltation at Home
        </div>

        <div className="focus-content">
         <p>
           While e-rehabilitation has shown promise for home-based recovery, clinical adoption remains challenging because successful rehabilitation depends on patients performing exercises correctly, integrating them into daily activities, and adhering consistently to their programs. 
           This research explores the use of Advanced Sensing (AS), Artificial Intelligence (AI), and Augmented Feedback (AF) to address these challenges for home rehabilitation of stroke patients, aiming to enhance movement quality and adaptability. We will develop a holistic solution that integrates multiple components: 
           a novel movement sensor kit to capture kinematic and kinetic data both indoors and outdoors; an AI agent that gathers patients’ subjective experiences through natural dialogue; AI models that analyze movement, provide corrective feedback, assess experiences, estimate daily load, and adapt exercises; and a dual platform comprising a patient-facing home exercise interface and professional monitoring tools.
         </p>

        </div>

      </section>



      {/* Focus 3 */}
      <section className="research-focus">

        <div className="focus-title">
          Human–Data Interactions for Participatory Health
        </div>

        <div className="focus-content">
          <p>
            The healthcare model is shifting from a clinician-driven approach to a participatory health model, where patients actively take part in managing their own health. Advances in mobile health apps and wearable sensors now allow individuals to track and manage their behaviors, 
            experiences, and lifestyles. As a result, personal life data has become a central resource for self-monitoring and health improvement, extending beyond traditional medical records. However,
            consistent data collection, meaningful interpretation, and sustained engagement with personal health data remain challenging, often limiting the effectiveness of even the most advanced technologies. 
            To address this, we propose a design-driven approach to participatory health, focusing on co-creating human–data interactions that seamlessly fit into users’ everyday lives while emphasizing the meaning and experience of data. This approach aims to make personal health data not only accessible but actionable, engaging, and relevant to each individual’s daily routines.
          </p>

        </div>

      </section>


      {/* Focus 4 */}
      <section className="research-focus">

        <div className="focus-title">
          Experiencial Biofeebdack for Stress Reduction
        </div>

        <div className="focus-content">
          <p>
         Traditional biofeedback systems often rely on explicit, goal-oriented metrics, such as graphs or scores, to help users regulate physiological signals like heart rate variability (HRV) and breathing. While effective in clinical settings, these systems can create performance pressure and reduce engagement for everyday users seeking relaxation. Experiential biofeedback reimagines this approach by embedding physiological signals into perceptual and aesthetic aspects of an environment, transforming internal states into ambient, intuitive feedback rather than evaluative indicators. By leveraging immersive and interactive media—such as VR or AR—experiential biofeedback can guide users toward relaxation through exploration, curiosity, and environmental richness, rather than explicit instruction. This approach supports both stress reduction and self-regulation skill learning while maintaining engagement, reducing anxiety, and enhancing the subjective quality of the experience.
         </p>


        </div>

      </section>

    </div>
  );
}

export default Research;
